import React, { useState, useEffect } from 'react';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { clearUrl } from '../../utils/helperFunctions';
import Moment from 'react-moment';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useLanguage } from '../../locales';
import { Link } from 'gatsby';
import {
  Article,
  ImageContainer,
  Typography,
  Title,
  TimeStamp,
} from './styles/BlogItem.styles';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
const BlogItem = ({ blog }) => {
  const { lang } = useLanguage();

  const visitPostURL = `/posts/${clearUrl(blog.slug)}`;
  return (
    <Article>
      <ImageContainer
        to={visitPostURL}
        onClick={() =>
          trackCustomEvent({
            category: 'post',
            action: 'click',
            label: blog.slug,
          })
        }
      >
        <LazyLoadImage
          src={`https:${blog?.image?.fixed?.src}`}
          alt={`https:${blog?.image?.fixed?.src}`}
          effect="blur"
        />
      </ImageContainer>
      <Typography>
        <Title>
          <Link
            to={visitPostURL}
            onClick={() =>
              trackCustomEvent({
                category: 'post',
                action: 'click',
                label: blog.slug,
              })
            }
          >
            {blog[`title_${lang}`]}
          </Link>
        </Title>
        <TimeStamp>
          <FaRegCalendarAlt />
          <Moment format="LL" locale={lang}>
            {new Date(blog.createdAt)}
          </Moment>
        </TimeStamp>

        <p>
          {blog[`description_${lang}`].split(' ').length > 30
            ? blog[`description_${lang}`].split(' ').slice(0, 30).join(' ') +
              ' ...'
            : blog[`description_${lang}`]}
        </p>
      </Typography>
    </Article>
  );
};

export default BlogItem;
